import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllPackages } from "../../api/apiPackages";
import parseError from "../../utils/parseError";

const useForceDeleteAllPackages = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllPkg,
        isPending: isForceDeleteAll,
    } = useMutation({
        mutationFn: forceDeleteAllPackages,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["packages"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete packages");
        },
    });

    return {
        forceDeleteAllPkg,
        isForceDeleteAll,
    };
};

export default useForceDeleteAllPackages;
